import { render, staticRenderFns } from "./proceso.vue?vue&type=template&id=e17828b0&"
import script from "./proceso.vue?vue&type=script&lang=js&"
export * from "./proceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports